import React, { useState ,useEffect} from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CheckoutSteps from "../../Components/CheckoutSteps";
import { savePaymentMethod } from "../../store/actions/cartActions";
function PaymentScreen(props) {
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;
  const [paymentMethod, setPaymentMethod] = useState(cart.paymentMethod);
  if(!shippingAddress.address){
    navigate('/shipping')
  }
  const dispatch = useDispatch()
  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentMethod));

    navigate('/placeorder')
  };

  const { cartItems } = cart;
  useEffect(() => {
    if(cartItems.length===0){
      navigate('/')
    }
  }, [navigate,cartItems]);
  return (
    <div>
      <CheckoutSteps step1 step2 step3 />
      <div className="shippingForm container my-3">
        <div className="shippingHeading my-5">
          <h2>Payment</h2>
        </div>
        <Form onSubmit={submitHandler}>
          <Row className="mb-3">
            <Col sm={10}>
              <Form.Check
                onChange={(e) => setPaymentMethod(e.target.value)}
                value="Paypal"
                type="radio"
                defaultChecked
                label="Paypal"
                name="paymentMethod"
                id="paymentMethod1"
              />
              <Form.Check
                onChange={(e) => setPaymentMethod(e.target.value)}
                value="Stripe"
                type="radio"
                label="Stripe"
                name="paymentMethod"
                id="paymentMethod2"
              />
            </Col>
          </Row>

          <Button
            type="submit"
            variant="contained"
            className="w-100 bg-warning text-dark"
          >
            Go To Next Step
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default PaymentScreen;
